<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="600" transition="dialog-bottom-transition" persistent>
      <v-card>
        <v-card-title class="text-h5 blue darken-4 white--text">
          Razones
          <v-spacer></v-spacer>
          <v-icon dark right @click="dialog = !dialog">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <p class="mb-4">
            Estas son algunas de las razones por las que no aparecen los programas para generar un recibo, en caso de que sea el "estado de la inscripcion", este estado puede cambiarse en la lista de inscritos de cada programa.
          </p>
          <p class="text-left mt-0 mb-0 blue--text" v-html="razones"></p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      razones: '',
    }),
    methods: {
      openmodal(razones) {
        window.console.log(razones);
        this.razones = razones;
        this.dialog = true;
      },
    },
    mounted() {},
  };
</script>
